export default {"src":"/_next/static/media/textile.a65df558.svg","height":75,"width":75};